import SeoArticleLayout from '@/components/feature/SeoArticleLayout';
import { seoArticles } from '@/mocks/seo-articles';

export default function AccessoriesGuidePage() {
  return <SeoArticleLayout article={seoArticles[5]} />;
}